var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-logo-container collapse"},[_c('div',{key:"collapse",staticClass:"sidebar-logo-link"},[(_vm.logo)?_c('img',{staticClass:"sidebar-logo",attrs:{"src":_vm.logo}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }